import {
  InfoIcon,
  LightbulbIcon,
  MessageSquareWarningIcon,
  TriangleAlertIcon,
  OctagonAlertIcon,
} from "lucide-react";

/** GitHub's own five alert kinds, in its colors: the glyph names the urgency, the title says it. */
export const GITHUB_ALERT_PRESENTATIONS: Record<
  string,
  { label: string; Icon: typeof InfoIcon; borderClassName: string; titleClassName: string }
> = {
  note: {
    label: "Note",
    Icon: InfoIcon,
    borderClassName: "border-info-border",
    titleClassName: "text-info-foreground",
  },
  tip: {
    label: "Tip",
    Icon: LightbulbIcon,
    borderClassName: "border-success-border",
    titleClassName: "text-success-foreground",
  },
  important: {
    label: "Important",
    Icon: MessageSquareWarningIcon,
    borderClassName: "border-hue-violet-border",
    titleClassName: "text-hue-violet-foreground",
  },
  warning: {
    label: "Warning",
    Icon: TriangleAlertIcon,
    borderClassName: "border-warning-border",
    titleClassName: "text-warning-foreground",
  },
  caution: {
    label: "Caution",
    Icon: OctagonAlertIcon,
    borderClassName: "border-destructive-border",
    titleClassName: "text-destructive-foreground",
  },
};
